
<template>
  <!-- 产品中心 -->
  <div class="newsCenterNav">
    <!-- 头部 -->

    <headerNav activeIndex="productCenter" @setBanner="setBanner"></headerNav>
    <!-- 轮播图 -->
    <bannerNav
      :carousel="info.carousel"
      :Mcarousel="info.Mcarousel"
    ></bannerNav>
    <div class="pc">
      <div>
        <div style="width: 1000px; margin: 96px auto 23px; text-align: center">
          <div
            class="Regular"
            style="
              font-size: 41px;
              color: #3f6b33;
              margin-bottom: 16px;
              line-height: 41px;
            "
          >
            <span>COMPOUND </span>
            <span style="color: #353535">LIQUOR</span>
          </div>
          <div
            class="Regular"
            style="
              font-size: 41px;
              color: #313131;
              margin-bottom: 29px;
              line-height: 41px;
            "
          >
            功效性植物复方原液原料
          </div>
          <div
            style="
              font-size: 21px;
              color: #313131;
              margin-bottom: 29px;
              line-height: 35px;
            "
          >
            御方汇推出的功效性植物复方原液原料均选用道地药材，采用独特的炮制工艺、中医药配伍原理，创新的专利提取技术、
            以及严格的质量控制标准，并经黄家圣幸中医院临床实践应用论证。
          </div>
        </div>
      </div>
      <div
        v-for="(item,index) of productList"
        :key="index"
        class="productNavList"
        :style="`margin-top:${getTop(index)}px`"
      >
        <div>
          <img
            :src="getUrlPrefix(item.coverImage)"
            style="width: 100%"
            alt=""
          />
        </div>
        <div
          v-if="item.type === '0'"
          style="
            position: absolute;
            bottom: 29px;
            left: 40%;
            width: 720px;
            height: 100%;
            display: flex;
            align-items: end;
          "
        >
          <div :id="`productIndex${index}`">
            <div
              class="Regular"
              style="
                color: #000000;
                font-size: 36px;
                white-space: pre-wrap;
                line-height: 1.2;
              "
            >{{ item.name }}</div>
            <div
              style="
                margin: 25px 0 19px;
                font-size: 27px;
                padding: 3px 0;
                width: 144px;
                text-align: center;
                background: #719468;
                color: #fff;
                border-radius: 50px;
              "
            >
              原料特点:
            </div>
            <div
              style="
                width: 600px;
                min-height: 160px;
                white-space: pre-wrap;
                color: #727171;
                font-size: 19px;
                line-height: 34px;
              "
            >{{ item.description }}</div>
            <div
              class="moreBtn"
              style="float: right"
              @click="goDetail(item.id)"
            >
              更多详细介绍
            </div>
          </div>
        </div>

        <div
          v-if="item.type === '1'"
          style="
            position: absolute;
            bottom: 29px;
            left: 25%;
            width: 720px;
            height: 100%;
            display: flex;
            align-items: end;
          "
        >
          <div :id="`productIndex${index}`">
            <div
              class="Regular"
              style="
                color: #000000;
                font-size: 36px;
                white-space: pre-wrap;
                line-height: 1.2;
              "
            >{{ item.name }}</div>
            <div
              style="
                margin: 25px 0 19px;
                font-size: 27px;
                padding: 3px 0;
                width: 144px;
                text-align: center;
                background: #719468;
                color: #fff;
                border-radius: 50px;
              "
            >
              原料特点:
            </div>
            <div
              style="
                width: 595px;
                min-height: 160px;
                white-space: pre-wrap;
                color: #727171;
                font-size: 19px;
                line-height: 34px;
              "
            >{{ item.description }}</div>
            <div class="moreBtn" @click="goDetail(item.id)">更多详细介绍</div>
          </div>
        </div>
      </div>

      <div style="width: 941px; margin: 96px auto 51px; text-align: center">
        <div
          class="Regular"
          style="
            font-size: 41px;
            color: #3f6b33;
            margin-bottom: 16px;
            line-height: 41px;
          "
        >
          EFFECT TEST REPORT
        </div>
        <div
          class="Regular"
          style="
            font-size: 41px;
            color: #313131;
            margin-bottom: 29px;
            line-height: 41px;
          "
        >
          功效性实验报告
        </div>
      </div>
      <div
        style="
          margin: 0 auto;
          display: flex;
          align-items: center;
          width: 1225px;
          flex-wrap: wrap;
          background: #719468;
          padding-left: 20px;
          padding-bottom: 40px;
        "
      >
        <div
          v-for="(item, index) of reportList"
          :key="index"
          style="text-align: center"
        >
          <div
            style="
              text-align: center;
              color: #fff;
              margin: 40px 20px 30px auto;
              font-size: 24px;
              line-height: 24px;
              display: inline-block;
              text-align: center;
              background: #3f6b33;
              border-radius: 50px;
              padding: 5px 14px;
            "
          >
            {{ item.categoryName }}
          </div>
          <div style="display: flex; align-items: center">
            <div
              v-for="(items, indexs) of item.reports"
              :key="indexs"
              class="enlarge1"
            >
              <img
                :src="getUrlPrefix(items.images)"
                alt=""
                style="width: 286px; margin-right: 20px"
              />
            </div>
          </div>
        </div>
      </div>
      <div style="width: 941px; margin: 96px auto 51px; text-align: center">
        <div
          class="Regular"
          style="
            font-size: 41px;
            color: #3f6b33;
            margin-bottom: 16px;
            line-height: 41px;
          "
        >
          SECURITY TEST REPORT
        </div>
        <div
          class="Regular"
          style="
            font-size: 41px;
            color: #313131;
            margin-bottom: 29px;
            line-height: 41px;
          "
        >
          安全性测试报告
        </div>
      </div>
      <div
        style="
          margin: 0 auto;
          display: flex;
          align-items: center;
          width: 1225px;
          flex-wrap: wrap;
          background: #f6f9f5;
          padding-left: 20px;
          padding-top: 40px;
          padding-bottom: 40px;
          margin-bottom: 101px;
        "
      >
        <div
          v-for="(item, index) of testReportList"
          :key="index"
          style="text-align: center"
          class="enlarge1"
        >
          <img
            :src="getUrlPrefix(item.images)"
            alt=""
            style="width: 286px; margin-right: 20px; margin-bottom: 20px"
          />
        </div>
      </div>
    </div>
    <div class="mobile">
      
      <div style="margin-top: 0.3rem; text-align: center">
        <div style="font-size: 0.28rem;line-height:1.4;color:#ddd;font-weight: 400;font-family: 'Proxima-Bold', sans-serif;text-transform: uppercase;">COMPOUND LIQUOR</div>
          <div style="color:#0f3a3c;font-weight: 600;margin-top:-4px;" class="fzTitle">功效性植物复方原液原料</div>
      </div>
      <div
        style="
          font-size: 0.16rem;
          color: #313131;
          line-height: 1.5;
          padding: 0.14rem 0.33rem 0.35rem;
          text-align: left;
        "
      >
        御方汇推出的功效性植物复方原液原料均选用道地药材，采用独特的炮制工艺、中医药配伍原理，创新的专利提取技术、以及严格的质量控制标准，并经黄家圣幸中医院临床实践应用论证。
      </div>
      <div>
        <div
          style="
            display: flex;
            align-items: center;
            padding: 0 0.1rem 0;
            background: #f5f7f5;
          "
        >
          <div
            style="
              margin-right: 0.2rem;
              text-align: left;
              color: #719468;
              height: 0.26rem;
              width: 0.26rem;
            "
            :style="nowProduct === 0?'opacity: 0.5;':''"
            @click="productLeft"
          >
            <i class="el-icon-arrow-left" style="line-height: 0.26rem"></i>
          </div>
          <div style="flex: 1; overflow-x: hidden;padding: 0.2rem 0;" 
              
            >
            <div
              style="align-items: center"
              :class="showAnimal ? 'animal' : ''"
              :style="`width:${
                productList.length * 100
              }%;transform: translateX(${
                0 - (100 / productList.length) * nowProduct
              }%);`"
            >
              <div :class="showAnimal ? 'animal' : ''" :style="`width: ${100 / productList.length}%;float:left;${nowProduct === index?'opacity: 1;':'opacity: 0;'}`" v-for="(item,index) of productList"
              >
                <div
                  class="bold"
                  style="color: #333; font-size: 0.2rem; white-space: pre-wrap;"
                >{{ item.name }}</div>
                <div
                  style="
                    margin: 0.2rem 0 0.1rem;
                    display: inline-block;
                    font-size: 0.12rem;
                    padding: 0.05rem 0.14rem;
                    text-align: center;
                    background: #719468;
                    color: #fff;
                    border-radius: 50px;
                  "
                >
                  原料特点:
                </div>
                <div
                  style="
                    white-space: pre-wrap;
                    color: #727171;
                    font-size: 0.14rem;
                    line-height: 1.6;
                    display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 9;
              overflow: hidden;
                  "
                  @touchstart='touchStart($event)'
                  @touchmove='touchMove($event)'
                  @touchend='touchEnd($event,item.id)'
                  @click="goDetail(item.id)"
                >{{ item.description }}</div>
                <div class="moreBtn" style="display: inline-block;" @click="goDetail(item.id)">更多详细介绍</div>
              </div>
              <div style="clear:both;"></div>
            </div>
          </div>
          <div
            style="
              margin-left: 0.2rem;
              text-align: right;
              color: #719468;
              height: 0.26rem;
              width: 0.26rem;
            "
            :id="nowProduct +','+productList.length"
            :style="nowProduct === productList.length - 1?'opacity: 0.5;':''"
            @click="productRight"
          >
            <i class="el-icon-arrow-right" style="line-height: 0.26rem"></i>
          </div>
        </div>
      </div>
      <div style="margin-top: 0.3rem; text-align: center">
        <div style="font-size: 0.28rem;line-height:1.4;color:#ddd;font-weight: 400;font-family: 'Proxima-Bold', sans-serif;text-transform: uppercase;">effect Test report</div>
          <div style="color:#0f3a3c;font-weight: 600;margin-top:-4px;" class="fzTitle">功效性实验报告</div>
      </div>
      <div style="background:#719468;margin-top:0.2rem;">
        <div style="display:flex;align-items:center;padding:0.2rem;">
          <div v-for="(item, index) of reportList" :key="index" 
            class="border-radius animal"
            style="text-align: center;flex:1;font-size:0.12rem;padding:0.07rem 0;margin:0 0.05rem;"
            :style="nowIndex === index?`background:#fff;color:#000;`:'background:#cde8c6;color:#000;'"
            @click="switchIndex(index)"
          >
            {{ item.categoryNameM }}
          </div>
        </div>
        <div
          class="partners maxWidth"
          style="
            width: calc(100% - 0.4rem);
            display: flex;
            align-items: center;
            padding: 0.1rem 0.2rem;
          "
        >
          <div style="margin: 0 0.08rem; width: 100%;overflow:hidden;width:100%;" 
          
              @touchstart='touchStart1($event)'
              @touchmove='touchMove1($event)'
              @touchend='touchEnd1($event)'>
            <div
              class="animal"
              :style="`display: -webkit-box;transform: translateX(-${nowIndex}00%);-webkit-box-align: start;`"
            >
              <template v-for="(item, index) of reportList">
                <div :key="index" 
                  style="display: flex;align-items:center; width: 100%;flex-wrap:wrap;"
                  class="animal"
                  :style="`opacity:${index === nowIndex?'1':'0'}`">
                    <template v-for="(item2, index2) of item.reports">
                      <div
                        class="partners-img"
                        :key="index2"
                      >
                        <img
                          :src="getUrlPrefix(item2.images)"
                          style="width: 100%"
                          alt=""
                        />
                      </div>
                    </template>
                </div>
              </template>
            </div>
          </div>
          
        </div>
      </div>
      <div style="margin-top: 0.3rem; text-align: center">
        <div style="font-size: 0.28rem;line-height:1.4;color:#ddd;font-weight: 400;font-family: 'Proxima-Bold', sans-serif;text-transform: uppercase;">security Test report</div>
          <div style="color:#0f3a3c;font-weight: 600;margin-top:-4px;" class="fzTitle">安全性测试报告</div>
      </div>
      
      <div
        style="
          margin: 0 auto;
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          justify-content:space-between;
          background: #f6f9f5;
          padding: 0.2rem;
          margin-top: 0.2rem;
          margin-bottom: 0.2rem;
        "
      >
        <div
          v-for="(item, index) of testReportList"
          :key="index"
          style="text-align: center;width: 22%;"
        >
          <img
            :src="getUrlPrefix(item.images)"
            alt=""
            style="width: 100%; margin-bottom: 0.05rem"
          />
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <RightBar></RightBar>
    <footerNav></footerNav>
  </div>
</template>

<script>
import headerNav from '@/components/headerNav/index'
import bannerNav from '@/components/banner/index'
import footerNav from '@/components/footerNav/index'
import {
  getProductList,
  getExperimentReportList,
  getTestReportList,
} from '@/api/product'

export default {
  name: 'newsCenter',
  components: { headerNav, footerNav, bannerNav },
  data() {
    return {
      info: {
        carousel: [],
        Mcarousel: '',
      }, //轮播图
      mobile: false,
      productList: [], //产品列表
      reportList: [], //实验报告
      testReportList: [], //测试报告
      nowProduct: 0,
      showAnimal: false,
      nowIndex:0,
      lastIndex:0,
      reportListChild:[],
      left:0,
      touchStartX: 0, // 触屏起始点x  
				touchStartY: 0, // 触屏起始点y  
        delta:50
    }
  },
  mounted() {
    this.mobile = this.isMobile()
    this.getProductCenterData()
    if(this.isMobile() === true){
      this.postMessage(
          '御方汇植物化妆品原料【官网】',
          '原料中心',
          window.location.href,
          this.getUrlPrefix(this.getBaseInfo().logo)
        );
    }
  },
  methods: {
    setBanner(url,mUrl) {
      this.info = {
        carousel: [url],
        Mcarousel: [mUrl],
      }
    },
    getTop(index){
      var top = 0
      console.log(index,$("#productIndex"+index).height())
      top = $("#productIndex"+index).height() - 360
      if(top < 50){
        top = 50
        if(index === 0){
          top = 0
        }
      }
      return top
    },
    goDetail(id) {
      this.$router.push({ name: 'productCenterDetail', params: { id: id } })
    },
    /**
     * 加载图片，直到加载完成后才调用回调函数
     * @param url 后面读取图片流的url
     * @param callback 回调函数
     */
    loadImage(url, callback) {
      var img = new Image()
      img.src = url
      var timer = setInterval(function () {
        if (img.complete) {
          callback(img)
          clearInterval(timer)
        }
      }, 50)
    },
    getProductCenterData() {
      getProductList().then((response) => {
        this.productList = response.data.list
        var that = this
        setTimeout(() => {
          that.showAnimal = true
        }, 1000)
      })
      getExperimentReportList().then((response) => {
        
        response.data.forEach(item => {
          item.categoryNameM = item.categoryName.replace('功效性实验报告','')
        });
        this.reportList = response.data
        this.reportListChild = response.data[0].reports
      })
      getTestReportList().then((response) => {
        this.testReportList = response.data
      })
    },
    switchIndex(index){
      if(this.lastIndex > this.nowIndex){
        this.left = "left"
      }
      if(this.lastIndex < this.nowIndex){
        this.left = "right"
      }
      this.lastIndex = this.nowIndex
      this.nowIndex = index
      this.reportListChild = this.reportList[index].reports
    },
    productLeft() {
      if (this.nowProduct === 0) {
        return
      } else {
        this.nowProduct--
      }
    },
    productRight() {
      if (this.nowProduct === this.productList.length - 1) {
        return
      } else {
        this.nowProduct++
      }
    },
    touchStart(e){
        // e.preventDefault && e.preventDefault(); //阻止文字选中等 浏览器默认事件
				this.touchStartX = e.touches[0].clientX;
				this.touchStartY = e.touches[0].clientY;
    },
    touchMove(event){
      var a =  this.touchStartX - event.touches[0].clientX;
      var w = a<0?a*-1:alert
      if(w > 5){
        event.preventDefault();
      }
    },
    touchEnd(e,id){
				let deltaX = e.changedTouches[0].clientX - this.touchStartX;
				let deltaY = e.changedTouches[0].clientY - this.touchStartY;
        // console.log(deltaX,deltaY)
				// X轴的滑动距离大于 delta，且此次事件是以X轴移动为主（左滑或者右滑）；
				if (Math.abs(deltaX) > this.delta && Math.abs(deltaX) > Math.abs(deltaY)) {
					if (deltaX >= 0) {
						// console.log("右滑")
            this.productLeft()
					} else {
						// console.log("左滑")
            this.productRight()
					}
				// Y轴的滑动距离大于 delta，且此次事件是以Y轴移动为主（上滑或者下滑）；
				} else if (Math.abs(deltaY) > this.delta && Math.abs(deltaX) < Math.abs(deltaY)) {
					if (deltaY < 0) {
						// console.log("上滑")
						this.$emit('fingerToT')
					} else {
						// console.log("下滑")
						this.$emit('fingerToB')
					}
				// 两轴位移都特别小，可以判断是点击
				} else if (Math.abs(deltaY) < 25 && Math.abs(deltaX) < 25) {
					console.log("点击")
          // this.goDetail(id)
				} else {
					console.log("可能是误触")
				}
    },
    touchStart1(e){
        console.log("触摸开始")
        // e.preventDefault && e.preventDefault(); //阻止文字选中等 浏览器默认事件
				this.touchStartX = e.touches[0].clientX;
				this.touchStartY = e.touches[0].clientY;
    },
    touchMove1(event){
      var a =  this.touchStartX - event.touches[0].clientX;
      var w = a<0?a*-1:a
      if(w > 5){
        event.preventDefault();
      }
    },
    touchEnd1(e){
      console.log("触摸结束")
				let deltaX = e.changedTouches[0].clientX - this.touchStartX;
				let deltaY = e.changedTouches[0].clientY - this.touchStartY;
        console.log(deltaX,deltaY)
				// X轴的滑动距离大于 delta，且此次事件是以X轴移动为主（左滑或者右滑）；
				if (Math.abs(deltaX) > this.delta && Math.abs(deltaX) > Math.abs(deltaY)) {
					if (deltaX >= 0) {
						console.log("右滑")
            console.log(this.nowIndex)
            if(this.nowIndex !== 0){
              this.nowIndex = this.nowIndex - 1
              this.left = "right"
              this.switchIndex(this.nowIndex)
            }
					} else {
						console.log("左滑")
            console.log(this.nowIndex,this.reportList.length)
            if(this.nowIndex !== this.reportList.length - 1){
              this.nowIndex = this.nowIndex + 1
              this.left = "left"
              this.switchIndex(this.nowIndex)
            }
					}
				// Y轴的滑动距离大于 delta，且此次事件是以Y轴移动为主（上滑或者下滑）；
				} 
    },
    getAngle(angx, angy) {
           return Math.atan2(angy, angx) * 180 / Math.PI;
       },
       getDirection(startx, starty, endx, endy) {
           var angx = endx - startx;
           var angy = endy - starty;
           var result = 0; //默认标记没有滑动
           //如果滑动距离太短
           if (Math.abs(angx) < 2 && Math.abs(angy) < 2) {
               return result;
           }
           var angle = this.getAngle(angx, angy);
           if (angle >= -135 && angle <= -45) {
               result = 1; //向上
           } else if (angle > 45 && angle < 135) {
               result = 2; //向下
           } else if ((angle >= 135 && angle <= 180) || (angle >= -180 && angle < -135)) {
               result = 3; //向左
           } else if (angle >= -45 && angle <= 45) {
               result = 4; //向右
           }
           return result;
       },
  },
}
</script>

<style lang="scss">
.newsCenterNav {
  .pc {
    .moreBtn {
      width: 124px;
      text-align: center;
      font-size: 15px;
      color: #719468;
      line-height: 15px;
      padding: 5px 0;
      border-radius: 50px;
      border: 1px solid #719468;
      margin-top: 22px;
    }
    .moreBtn:hover {
      color: #fff;
      background: #719468;
      cursor: pointer;
    }
    .productNavList{
      position: relative; min-height: 360px;
    }
  }
  .mobile {
    .moreBtn {
      background: linear-gradient(45deg, #7ace63 0%, #3f6b33 100%);
      margin: 0.2rem 0 0 0.02rem;
      padding: 0.05rem 0.08rem;
      color: #fff;
      font-size: 0.12rem;
    }
    .partners {
    padding: 40px 68px 32px;
    align-items: center;
    display: -webkit-box;
    .partners-img {
      width: 31%;
      background: #fff;
      margin-right: 2%;
      display: flex;
      margin-bottom:0.1rem;
      align-items: center;
      img {
        background: #fff;
      }
    }
    .partners-img:last-child {
      margin-right: 0;
    }
  }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/productCenter/index.vue